/**
 * generate random token
 * @return {string}
 */
export default function randomToken(){
 return Math.random().toString(36).substring(2);
}
